export default {
  "content": "<path d=\"M6.521 18.333L5 16.792 11.792 10 5 3.208l1.521-1.541L14.854 10l-8.333 8.333z\" fill=\"currentColor\"/>",
  "attrs": {
    "width": "20",
    "height": "20",
    "viewBox": "0 0 20 20",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};